module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/zion_national_park-02ef71792632c19aebe04a83e8b11b97.jpg";